import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';
import Maintenance from '@ui/components/Maintenance.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...routes,
    {
      path: '/maintenance',
      component: Maintenance,
      name: 'maintenance',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== 'maintenance' &&
    (process.env.STUUT_MAINTENANCE_MODE?.toLowerCase() === 'true' ||
      process.env.STUUT_MAINTENANCE_MODE === '1')
  ) {
    next({ name: 'maintenance' });
  } else {
    next();
  }
});

export default router;
